// Extending the Array prototype in TypeScript
interface Array<T> {
    select<TResult>(selector: (item: T) => TResult): Array<TResult>;
    where(predicate: (item: T) => boolean): Array<T>;
    orderBy<TKey>(keySelector: (item: T) => TKey): Array<T>;
}

// LINQ-style extension for Select
Array.prototype.select = function <T, TResult>(selector: (item: T) => TResult): Array<TResult> {
    return this.map(selector);
};

// LINQ-style extension for Where (equivalent to filter)
Array.prototype.where = function <T>(predicate: (item: T) => boolean): Array<T> {
    return this.filter(predicate);
};

// LINQ-style extension for OrderBy
Array.prototype.orderBy = function <T, TKey>(keySelector: (item: T) => TKey): Array<T> {
    return [...this].sort((a, b) => {
        const keyA = keySelector(a);
        const keyB = keySelector(b);
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
    });
};

interface Date {
    addDays(days: number): Date;
    subtractDays(days: number): Date;
    hasValue(): boolean;
}

Date.prototype.addDays = function (days: number): Date {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

Date.prototype.subtractDays = function (days: number): Date {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() - days);
    return date;
};

Date.prototype.hasValue = function (): boolean {
    return this !== null && this !== undefined;
};